/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.Model = M.Model || {};

  /**
   * @class M.Model.CommunityComment
   * This model makes it simple to work with comments from the front end
   * without touching PHP.
   */
  M.Model.CommunityComment = Backbone.Model.extend({
    initialize: function() {
      // The url root path is defined in python and passed through layers
      // of js object here
      this.urlRoot = this.get('urlPaths')['communityCommentModelUrlRoot'];
    }
  });

})(M, _, $, Backbone);

